import { technologies } from '../../../mocks/featuresData';

export default function TechnologySection() {
  return (
    <section id="technology" className="py-32 bg-dark relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>

      <div className="max-w-[1200px] mx-auto px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-white mb-6">
            Gebaut mit modernster Technologie
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Enterprise-grade Tools für maximale Performance, Sicherheit und Skalierbarkeit
          </p>
        </div>

        {/* Technology Grid */}
        <div className="grid grid-cols-5 gap-10">
          {technologies.map((tech) => (
            <div
              key={tech.id}
              className="bg-dark rounded-2xl p-8 border border-primary/20 transition-all duration-300 hover:border-primary hover:shadow-xl hover:shadow-primary/20 cursor-pointer group flex flex-col items-center text-center"
              style={{ height: '280px' }}
            >
              {/* Icon */}
              <div className="w-20 h-20 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                <i 
                  className={`${tech.icon} text-6xl`}
                  style={{ color: tech.color }}
                ></i>
              </div>

              {/* Name */}
              <h3 className="text-xl font-bold text-white mb-4">
                {tech.name}
              </h3>

              {/* Description */}
              <p className="text-sm text-gray-400 leading-relaxed">
                {tech.description}
              </p>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-20 text-center">
          <p className="text-gray-400 text-lg mb-8">
            Und viele weitere moderne Technologien für Ihre individuellen Anforderungen
          </p>
          <div className="flex items-center justify-center gap-6">
            <div className="flex items-center gap-2 text-gray-400">
              <i className="ri-shield-check-line text-primary text-2xl"></i>
              <span>Enterprise Security</span>
            </div>
            <div className="flex items-center gap-2 text-gray-400">
              <i className="ri-speed-line text-primary text-2xl"></i>
              <span>High Performance</span>
            </div>
            <div className="flex items-center gap-2 text-gray-400">
              <i className="ri-cloud-line text-primary text-2xl"></i>
              <span>Cloud Native</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
